<template>
    <div class="cookie-terms container">
        <h1>Política de Cookies</h1>

        <p class="text-body-1 ">
            A leitura desta Política de Cookies é necessária para que você saiba como usamos cookies.

            Quando você navega em nosso site, você poderá ser convidado a preencher algumas informações:

            O AFV Web é voltado para fornecer um sistema de força de vendas especializado no mercado de serviços financeiros voltado a venda de consórcio.

            É importante considerar que o AFV Web poderá realizar atualizações em suas Políticas de Cookies e, se em alguma das atualizações você, na qualidade de usuário, discordar de nossas Políticas de Uso de Cookies, sugerimos que você não navegue mais em nossa plataforma e ainda, quando necessário, entre em contato conosco para tirar as suas dúvidas.

            Quando você acessar a nossa página e estiver logado em nosso sistema, poderão ser coletados dados destinados a determinar seus interesses, as suas páginas visitadas, a frequência das visitas, sistema operacional e navegador utilizados. Para tanto, cookies poderão ser instalados em seu navegador.
        </p>
        <h2>E você sabe por que os cookies são usados?</h2>

        <p class="text-body-1">
            As páginas da web não têm memória própria. Se estiver navegando de uma página a outra, num mesmo website, você não será reconhecido como sendo o mesmo usuário em todas as páginas. Os cookies permitem que você seja reconhecido como o mesmo usuário navegando pelas páginas de um website. Os cookies permitem que suas escolhas sejam memorizadas tais como seu idioma, moeda de preferência e seus critérios de busca. Eles também garantem que você seja reconhecido ao acessar novamente o mesmo website.

            Existem alguns tipos de Cookies, por exemplo, os cookies que são estabelecidos pelo site, cookies que são definidos por terceiros.

            Importante você, na qualidade de usuário do site, deve ter o conhecimento de que existem os cookies temporários, ou seja, aqueles que não permanecem, são expirados assim que você fechar o navegador.

            Além disso, existem os cookies voltados para publicidade, assim, eles direcionam anúncios conforme os seus interesses.
        </p>
        <h2>Consentimento</h2>
        <p class="text-body-1">
            Para que ocorra a instalação dos cookies exemplificados acima, é preciso o seu consentimento, por isso, sinta-se livre para aceitar ou rejeitar os Cookies (o banner de alerta deverá aparecer em sua tela). A qualquer momento você poderá alterar, bloquear ou recusar os Cookies.

            Lembre-se que para nós, é fundamental que você leia atentamente a nossa Política de Uso de Cookies e, em caso de dúvidas, não hesite em entrar em contato através do nosso e-mail: <a href="mailto:atendimento@newm.com.br">atendimento@newm.com.br</a>
        </p>
    </div>
</template>

  <script>
  export default {
    name: 'CookiesTerms'
  }
  </script>

  <style scoped>
  .cookie-terms {
    padding: 20px 50px;
  }

  .body-1{
    font-size:1.2rem !important;
  }
  </style>
